import { ApiModule } from '../../api/services';

export class AutocompleteApi extends ApiModule {
  public search(endpoint: string, searchParams: any) {
    return this.api.get(`${endpoint}`, { params: searchParams });
  }
}
